// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "/**\n* Colors\n*/\n.MyCompany_header__1duzK > div:first-child {\n  align-items: center; }\n", ""]);
// Exports
exports.locals = {
	"header": "MyCompany_header__1duzK"
};
module.exports = exports;
